export const LOCALLY_CHANGED = 'LOCALLY_CHANGED';
